module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-e5cfe31a.png";